const videos = $('.video-wrap .video');

// video pause function
function pauseVideo(video, toggleClass = true) {
  video.pause();
  if (toggleClass === true) {
    $(video).siblings('.video-controls').addClass('paused');
  }
}

// video play function
function playVideo(video, toggleClass = true) {
  const promise = video.play();;

  if (promise !== undefined) {
    promise.then((_) => {
      // Autoplay started!
      if (toggleClass === true) {
        $(video).siblings('.video-controls').removeClass('paused reload');
      }
    }).catch((error) => {
      if (
        $(video).hasClass('autoplay') === true
        && (
          $(video).hasClass('inview-top') === true
          || $(video).hasClass('inview-bottom') === true
        )
      ) {
        $(video).prop('autoplay', true).prop('muted', true);
        $(video).siblings('.video-controls').removeClass('paused reload').addClass('muted');
        $(video)[0].play();
      } else {
        // Autoplay was prevented.
        // Show a "Play" button so that user can start playback.
        pauseVideo($(video)[0]);
      }
    });
  }
}

function toggleVideoState(video, toggleClass = true, forceState = null) {
  // force play/pause state
  if (forceState !== null) {
    if (forceState === 'play') {
      playVideo(video, toggleClass);
    } else if (forceState === 'pause') {
      pauseVideo(video, toggleClass);
    }

    // default behaviour to toggle play or pause
  } else if (video.paused == true) {
    playVideo(video, toggleClass);
  } else {
    pauseVideo(video, toggleClass);
  }
}
videos.each(function () {
  const video = this;
  const controls = $(this).siblings('.video-controls').find('span');

  // Event listener for the play/pause button
  controls.each(function () {
    this.addEventListener('click', function () {
      if ($(this).is('.video-control-pause, .video-control-play')) {
        toggleVideoState(video);
      } else if ($(this).is('.video-control-sound, .video-control-muted')) {
        if ($(video).prop('muted')) {
          $(video).prop('muted', false);
          $(this).parents('.video-controls').removeClass('muted');
        } else {
          $('video').prop('muted', true);
          $(this).parents('.video-controls').addClass('muted');
        }
      }
    });
  });
});

function convertVideoSrcAndLoad(video) {
  if ($(video).children('source[data-src]').length > 0) {
    $(video).children('source').each(function () {
      const source = this;
      const sourceSrc = $(source).attr('src');
      const dataSrc = $(source).attr('data-src');

      if (typeof sourceSrc === 'undefined' && typeof dataSrc !== 'undefined') {
        $(source).attr('src', dataSrc);
        $(source).removeAttr('data-src');
      }
    });
  }
}

function setVideoVolume(video) {
  const thisVideoControls = $(video).siblings('.video-controls');
  const thisVolumeControl = thisVideoControls.find('.video-control-volume');
  let volume = 0.4;

  if ($(video).hasClass('muted')) {
    volume = 0;
  }

  video.volume = volume;
  if (thisVolumeControl.length > 0) {
    thisVolumeControl.val(volume);

    thisVolumeControl.on('input', function (e) {
      const thisVolume = $(this).val();
      video.volume = thisVolume;

      const ratio = (this.value - this.min) / (this.max - this.min) * 100;
      this.style.background = `linear-gradient(180deg, var(--track-color-active) ${ratio}%, var(--track-color-inactive) ${ratio}%)`;
    });
  }
}

function getVideoEnded(video) {
  $(video).on('timeupdate', function (e) {
    if (this.currentTime === this.duration) {
      $(this).siblings('.video-controls').addClass('paused reload');
    }
  });
}

$(document).ready(() => {
  videos.each(function () {
    const video = this;
    if ($(video).hasClass('autoplay')) {
      convertVideoSrcAndLoad(video);
      video.load();
      setVideoVolume(video);
      getVideoEnded(video);
    }
  });
});

// change active video in video gallery
$('.videogallery-wrap .gallery-item').each(function () {
  this.addEventListener('click', (e) => {
    let loadingDelay = 0;
    const fullVideoWrap = $(e.target).parents('.ce-content').first().find('.videos-full-wrap');
    const activeVideo = fullVideoWrap.find('.active video');
    activeVideo[0].pause();
    activeVideo.siblings('.video-controls').addClass('paused');
    const $target = $(e.target);
    let $this;

    if ($target.hasClass('.gallery-item') === true) {
      $this = $target;
    } else {
      $this = $target.parents('.gallery-item');
    }

    const thisFullVideoWrap = fullVideoWrap.find(`.video-wrap[data-video-index="${$this[0].dataset.videoIndex}"]`);
    const thisFullVideo = thisFullVideoWrap.children('video');

    if (thisFullVideo.attr('preload') === 'none') {
      thisFullVideo.prop('preload', 'metadata');
      const tempVideo = thisFullVideo[0];
      convertVideoSrcAndLoad(tempVideo);
      tempVideo.load();
      setVideoVolume(tempVideo);
      getVideoEnded(tempVideo);
      loadingDelay = 90;
    }

    setTimeout(() => {
      $target.parents('.ce-content').first().find('.video-wrap.active, .gallery-item.active').removeClass('active');
      thisFullVideoWrap.addClass('active');
      $target.addClass('active');

      /* autoplay chosen video */
      thisFullVideo.prop('muted', false);
      thisFullVideo[0].play();
      thisFullVideo.siblings('.video-controls').removeClass('paused reload').removeClass('muted');

      const offsetTop = thisFullVideoWrap.offset().top;
      $('html, body').animate({
        scrollTop: `${offsetTop}px`,
      }, 500);
    }, loadingDelay);
  });
});

// intersection observer for autoplay
$(window).on('load', () => {
  // work with 15% of desktop height as offset
  let offsetY = window.innerHeight / 15;

  if (window.matchMedia('(min-width:992px)').matches) {
    // work with 5% of desktop height as offset
    offsetY = window.innerHeight / 5;
  }

  const observerConfigVideos = {
    root: null,
    rootMargin: `-${offsetY}px 0px`,
    threshold: 0,
  };
  let previousY = 0;
  let previousRatio = 0;

  const observer = new IntersectionObserver(((videos) => {
    videos.forEach((video) => {
      const currentY = video.boundingClientRect.y;
      const currentRatio = video.intersectionRatio;
      const { isIntersecting } = video;
      const element = video.target;

      if (isIntersecting === true) {
        element.classList.add('element-seen');
      }

      element.classList.remove('outview-top', 'inview-top', 'inview-bottom', 'outview-bottom');
      // Scrolling up
      if (currentY < previousY) {
        const className = (currentRatio >= previousRatio) ? 'inview-top' : 'outview-top';
        element.classList.add(className);

        // Scrolling down
      } else if (currentY > previousY) {
        const className = (currentRatio <= previousRatio) ? 'outview-bottom' : 'inview-bottom';
        element.classList.add(className);
      }

      // trigger autoplay by given classes
      if ($(element).parents('.video-wrap.active').length > 0) {
        if (
          $(element).siblings('.video-controls').length > 0
          && $(element).is('.autoplay[class*="inview-"]') === true
        ) {
          toggleVideoState(element, false, 'play');
        } else if ($(element).is('[class*="outview-"]') === true) {
          toggleVideoState(element, false, 'pause');
        }
      }

      previousY = currentY;
      previousRatio = currentRatio;
    });
  }), observerConfigVideos);

  setTimeout(() => {
    const tVideos = document.querySelectorAll('video.video');
    for (let i = 0; i < tVideos.length; i += 1) {
      observer.observe(tVideos[i]);
    }
  }, 50);
});

// play video on click on wrapper
$('.videos-full-wrap').on('click', (e) => {
  $(e.target).parents('.video-wrap').find('video.autoplay').removeClass('autoplay');
  if ($(e.target).parents('.video-controls').length === 0) {
    toggleVideoState($(e.currentTarget).find('.video-wrap.active video').get(0));
  }
});
